import * as React from 'react';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withRouteAwareIframe from 'pages/utils/withRouteAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';
import { RouteComponentProps } from 'react-router-dom';
import { paths } from '../routes';

const CardSalesDateIframe: React.FC<RouteComponentProps<{ date: string }>> = ({ match }) => {
  React.useEffect(() => {
    window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
      props: {
        crumbs: [
          {
            text: 'Reports',
            name: 'reports',
            type: 'ui_tab',
          },
          {
            text: 'Card sales',
            page: paths.cardSales,
          },
          {
            text: match.params.date,
          },
        ],
      },
    });
  });

  return (
    <>
      <style
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `.react-page { height: 100% }`,
        }}
      />
      <iframe
        title="Display card sales details for a specific date"
        src={`/webapps_redirect.php?app=retail-reports&next=${encodeURIComponent(
          `/payments/overview/${match.params.date}${window.location.search}`
        )}`}
        style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
      />
    </>
  );
};

export default withLocalizeAwareIframe(
  withRouteAwareIframe(withValidSessionIframe(CardSalesDateIframe))
);
